/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

import { GroupHeaderController } from './group-header-component';

/**
 * AngularJS component that handles rendering all the details and information regarding members in a group.
 */
const groupBlockDetailsComponent = {
  templateUrl: 'ajs/components/group/group-block-details.html',
  bindings: {
    unit: '=',
  },
  controllerAs: 'groupHeaderCtrl',
  controller: ['$attrs', '$rootScope', '$scope', '$state', '$translate', '$window', 'Restangular',
    'AeroDialogService', 'BulbAuthService', 'BulbBrowserService', 'BulbBusyService',
    'BulbGoogleClassroomImportService', 'BulbGroupService', 'BulbModalService', 'BulbUtilitiesService',
    'AUTH', 'GROUP', GroupHeaderController],
};

export default groupBlockDetailsComponent;
